
import React from 'react';
import '../css/About.css';
import Alex from '../images/AlexPic.jpeg'

const About = () => (
  <>
    <div className="about-container">
      <img alt="Alex" id="alex-pic" src={Alex} />
      <h1>Alex Marvick</h1>
      <p>Software Developer</p>
      <p>Washington, D.C.</p>
    </div>
    {/* <div className="about-me">
      <h1>ABOUT ME</h1>
      <p>
        I'm a software developer currently living in Washington, D.C.
        I work primarily with front end tools including React.js, TypeScript, React Native and Redux while
        working with Node.js and HackLang on the back end.
        </p>
      <p>
        In my free time, I enjoy mid-long distance running, learning the Norwegian language, music, drinking coffee, NBA and learning in general.
        If you want to chat, send me a note!
      </p>
    </div> */}
  </>
);

export default About;
